import { createContext, type ReactNode, useContext } from "react";

export type NavigateTo = (to: string) => void;

const defaultNavigate: NavigateTo = (to) => {
  if (typeof window !== "undefined") {
    window.location.href = to;
  }
};

const NavigationContext = createContext<NavigateTo>(defaultNavigate);

/**
 * Lets foundation components render real links without importing the router. The shell
 * supplies the router's navigate once; tests get the harmless default.
 */
export function NavigationProvider({
  navigate,
  children,
}: {
  navigate: NavigateTo;
  children: ReactNode;
}) {
  return <NavigationContext.Provider value={navigate}>{children}</NavigationContext.Provider>;
}

export function useNavigateTo(): NavigateTo {
  return useContext(NavigationContext);
}
